module.exports = __webpack_public_path__ + "media/30.e3aed872.ogg";